import { Schedule } from '@core/models';
import { IStoreStatus } from '../interfaces';

function parseTimeString(timeStr: string): number {
	const [hours, minutes] = timeStr.split(':').map(Number);
	return (hours || 0) * 100 + (minutes || 0);
}

/**
 * Checks whether a store is currently open based on its schedules and computes the next status change.
 */
export function checkStoreStatus(horarios: Schedule[], referenceDate: Date = new Date()): IStoreStatus {
	const today = referenceDate.toLocaleString('en-US', { weekday: 'long' }).toLowerCase();
	const currentTime = referenceDate.getHours() * 100 + referenceDate.getMinutes();

	const todaySchedule = horarios?.find(h => h.dia === today);
	if (!todaySchedule || !todaySchedule.apertura || !todaySchedule.cierre) {
		return { isOpen: false, nextChange: 'Cerrado hoy' };
	}

	const openingTime = parseTimeString(todaySchedule.apertura);
	const closingTime = parseTimeString(todaySchedule.cierre);

	let isOpen: boolean;
	if (closingTime < openingTime) {
		isOpen = currentTime >= openingTime || currentTime <= closingTime;
	} else {
		isOpen = currentTime >= openingTime && currentTime <= closingTime;
	}

	const nextChange = isOpen
		? `Closes at ${todaySchedule.cierre}`
		: `Opens at ${todaySchedule.apertura}`;

	return { isOpen, nextChange };
}
